import { render, staticRenderFns } from "./ViewProposta.vue?vue&type=template&id=26f03aa2"
import script from "./ViewProposta.vue?vue&type=script&lang=js"
export * from "./ViewProposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports